import React from 'react'
import { breadcrumbDiscountPharmacies } from '../../constants'
import { useBenefitsContext } from '../../contexts/BenefitsContext'
import Breadcrumb from '@/components/Breadcrumb'
import LoadingPage from '@/components/LoadingPage'
import useStyles from './styles'
import CustomLayout from '@/components/CustomLayout'
import logoPagueMenos from '@/assets/logo-pague-menos.png'

const DiscountPharmacies: React.FC = () => {
  const { discountPharmaciesContainer, containerText } = useStyles()
  const { loading } = useBenefitsContext()

  return (
    <CustomLayout>
      <Breadcrumb items={breadcrumbDiscountPharmacies} currentStep={1} />

      <div css={discountPharmaciesContainer}>
        <h2>Desconto em farmácias</h2>

        {loading ? (
          <LoadingPage withoutNav />
        ) : (
          <>
            <img src={logoPagueMenos} alt="logo do Pague Menos" />
            <p>
              Você tem direito a descontos na rede de farmácias Pague Menos.
              Para usá-los, basta ir ao balcão da loja, informar o seu CPF e
              mostrar um documento de identificação com foto, além da receita
              médica.
            </p>
            <div css={containerText}>
              <p>
                Localize a{' '}
                <a
                  href="https://www.paguemenos.com.br/nossas-lojas"
                  target="_blank"
                  rel="noreferrer"
                >
                  unidade mais próxima de você.
                </a>
              </p>
            </div>
          </>
        )}
      </div>
    </CustomLayout>
  )
}

export default DiscountPharmacies
